module.exports = __webpack_public_path__ + "assets/b392df8e1e169592f1694a12f858c15f.png";